<template>
    
                <div class="news-items mt54">

                    <a href="https://mp.weixin.qq.com/s/pdUaji9HrNIF8c2beM2p1Q" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20260206/001.png" alt="珠港澳跨境信用服务平台 3.0 重磅升级 跨境信用服务迈入“全球通”时代" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">02/06<span>2026</span></div></div>
                            <div class="info">
                                <div class="title">珠港澳跨境信用服务平台 3.0 重磅升级 跨境信用服务迈入“全球通”时代</div>
                                <div class="desc">澳门融贯投资科技有限公司深度参与大湾区跨境信用互认，依托“星火・链网”构建可信数据网络，推动澳门居民信用信息与内地合规互通，为平台跨境信用互通互认提供关键技术与本地实践支撑。 </div>
                            </div>
                        </div>
                    </a>
                    <a href="https://mp.weixin.qq.com/s/_mPTO40Hw2zePfI46h80cg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20260108/001.jpg" alt='澳门质量品牌国际认证联盟成功主办"2026山西浑源文旅康养及黄芪产业横琴推介会"' class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">01/08<span>2026</span></div></div>
                            <div class="info">
                                <div class="title">澳门质量品牌国际认证联盟成功主办"2026山西浑源文旅康养及黄芪产业横琴推介会"</div>
                                <div class="desc">2026山西大同浑源文旅康养及黄芪产业横琴推介会，今日上午九时半假横琴希尔顿花园酒店举行，本次大会以"恒山黄芪 中华正气"为主题，聚焦恒山黄芪由道地资源优势向现代产业体系、国际健康资源转化的关键路径，集中展示产业升级成果，推动区域协同发展与国际合作。 </div>
                            </div>
                        </div>
                    </a>


                    <a href="https://mp.weixin.qq.com/s/qvl55vHUdt9bW8hWuwImqQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251214/001.jpg" alt="蓉澳合作——大熊猫国家公园文创产业联盟 2025 年会暨熊猫经济产业建圈强链研讨会顺利举办" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/14<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">蓉澳合作——大熊猫国家公园文创产业联盟 2025 年会暨熊猫经济产业建圈强链研讨会顺利举办</div>
                                <div class="desc">2025年12月14日，“大熊猫国家公园文创产业联盟2025年会暨熊猫经济产业建圈强链研讨会” 在成都大学隆重举行。来自政府、学界、企业、媒体等领域的数百位代表齐聚一堂，共同探讨熊猫IP赋能与产业生态共兴的未来路径。澳门质量品牌国际认证联盟秘书长陈祥、澳门中葡商贸促进协会副秘书长于丁受邀出席。 </div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/Dsi9m1IKqvv0ERhXqP0-CQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251205/001.jpg" alt="【喜讯】澳门融贯获颁「潜力型科技企业」认证！以数字科技赋能湾区发展" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/05<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">【喜讯】澳门融贯获颁「潜力型科技企业」认证！以数字科技赋能湾区发展</div>
                                <div class="desc">我们荣幸地宣布，澳门融贯投资科技有限公司正式通过澳门特别行政区政府经济及科技发展局的严格评审，获认证为「潜力型科技企业」（认证编号：S091000131）！此项认证是对融贯国际在数字科技创新、技术落地能力及发展潜力的高度认可，有效期自公布日起三年。 </div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/pqX6ypXRNJMjJa4EttV4qw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251108/001.jpg" alt="澳门城市大学AI人工智能训练师（三级）培训班正式开班" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/08<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">澳门城市大学AI人工智能训练师（三级）培训班正式开班</div>
                                <div class="desc">2025年11月8日，澳门城市大学“智汇城大·创享未来——AI人工智能训练师（三级）”正式开班。本次培训创新采用“学历+国家技能证书”双轨培养模式，以AI人才培育为核心，整合政府、企业及高校资源，构建产教融合新平台，旨在拓宽澳门青年职业发展通道，助力粤港澳大湾区数字产业人才生态建设。 </div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/ns0dVf3iwNHZwsk9Sj4n_Q" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251029/001.jpg" alt="源自澳门的一口好茶：「茶业新物种」如何重塑中国茶产业格局？" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/29<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">源自澳门的一口好茶：「茶业新物种」如何重塑中国茶产业格局？</div>
                                <div class="desc">一颗标准化的茶胶囊，背后是澳门新业态品牌隆兴澳1915与现代数字技术的深度融合，正通过澳门这个国际窗口，悄然开启一场从种植到品饮的产业链革命。 </div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/BW7J4lxxFW28tQPKosJgTA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251028/001.jpg" alt="中国电信展示“神农一号”大模型，澳门平台推动中葡智慧农业合作" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/28<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">中国电信展示“神农一号”大模型，澳门平台推动中葡智慧农业合作</div>
                                <div class="desc">澳门威尼斯人金光会展中心内，中国电信的“神农一号”大模型吸引了众多葡语国家代表驻足。作为智慧农业的大脑，它正通过澳门这座桥梁走向葡语世界。 </div>
                            </div>
                        </div>
                    </a>

                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>